"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _mobxStateTree = require("mobx-state-tree");

var _default = function _default(pluginManager) {
  return _mobxStateTree.types.model('Connection', {
    name: _mobxStateTree.types.identifier,
    tracks: _mobxStateTree.types.array(pluginManager.pluggableConfigSchemaType('track'))
  }).actions(function (self) {
    return {
      afterAttach: function afterAttach() {
        if (!self.tracks.length) {
          self.connect(self.configuration);
        }
      },
      addTrackConf: function addTrackConf(trackConf) {
        var length = self.tracks.push(trackConf);
        return self.tracks[length - 1];
      },
      addTrackConfs: function addTrackConfs(trackConfs) {
        var _self$tracks;

        var length = (_self$tracks = self.tracks).push.apply(_self$tracks, (0, _toConsumableArray2.default)(trackConfs));

        return self.tracks.slice(length - 1 - trackConfs.length, length - 1);
      },
      setTrackConfs: function setTrackConfs(trackConfs) {
        self.tracks = trackConfs;
        return self.tracks;
      },
      clear: function clear() {}
    };
  });
};

exports.default = _default;